import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ContactUsTopicEnum } from '../../../modules/landing-area/contact-us/enum';
import { CustomValidatorsService } from '../../../shared/modules/inputs/services/custom.validators.service';

export function buildForm() {
  return new FormGroup({
    name: new FormControl(null, [
      Validators.required,
      Validators.maxLength(200),
    ]),
    type: new FormControl(ContactUsTopicEnum.ACCOUNT_ISSUES, [
      Validators.required,
    ]),
    email: new FormControl(null, [
      Validators.required,
      CustomValidatorsService.email,
    ]),
    message: new FormControl(null, [
      Validators.required,
      Validators.maxLength(4000),
    ]),
    recaptcha: new FormControl(null, [Validators.required]),
  });
}
